// extracted by mini-css-extract-plugin
export default {"Text":"InputLabel-module__Text--z_Liw","Box":"InputLabel-module__Box--ArYDY","Box_1":"InputLabel-module__Box_1--y4r_J"};